import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Container } from "../components/Container";
import { Card } from "../components/Card";
import { LoadingContainer } from "../components/LoadingContainer";
import { LoadMoreButton } from "../components/LoadMoreButton";
import { EmptyState } from "../components/EmptyState";
import { Title } from "../components/Title";
import { useGetChainsInfiniteQuery } from "../query/chainsQuery";
import { spacing } from "@styling/sizing";
import { List } from "../components/List";
import { ListItem } from "../components/ListItem";

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacing.x4}px;
`;

export const ChainsView = () => {
  const { t } = useTranslation();
  const {
    data: chainsData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useGetChainsInfiniteQuery();

  const allChains = chainsData?.pages.flatMap((page) => page) || [];

  if (isLoading && allChains.length === 0) {
    return (
      <Container>
        <PageHeader>
          <Title>{t("listPages.chainsTitle")}</Title>
        </PageHeader>
        <LoadingContainer message={t("listPages.chainsLoading")} />
      </Container>
    );
  }

  return (
    <Container>
      <PageHeader>
        <Title>{t("listPages.chainsTitle")}</Title>
      </PageHeader>

      {allChains.length === 0 ? (
        <Card>
          <EmptyState message={t("listPages.emptyChains")} />
        </Card>
      ) : (
        <>
          <List>
            {allChains.map((chain) => (
              <ListItem
                key={chain.id}
                to={`/chains/${chain.id}`}
                title={chain.name}
                subTitle={t("common.listIdSubtitle", { id: chain.id })}
              />
            ))}
          </List>
          <LoadMoreButton
            onClick={() => fetchNextPage()}
            isLoading={isFetchingNextPage}
            hasMore={hasNextPage}
          />
        </>
      )}
    </Container>
  );
};

